import { Action } from "redux"
import * as actions from "./actions"
import { IDeployment } from "./index"

export const initialState: IDeployment = {
    configurations: [],
    configurationsLoading: false,
    editor: {
        visible: false,
        source: undefined,
    },
    packageDiffs: {},
}

const handlers: {
    [action: string]: (state: IDeployment, props: Action) => IDeployment
} = {
    [actions.SET_INITIALIZED]: (state): IDeployment => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_CONFIGURATIONS]: (state) => ({
        ...state,
        configurationsLoading: true,
    }),

    [actions.REQUEST_INSTALLED_CONFIGURATIONS]: (state) => ({
        ...state,
        configurationsLoading: true,
    }),

    [actions.RECEIVE_CONFIGURATIONS]: (
        state,
        { configurations }: actions.ReceiveConfigurations,
    ): IDeployment => ({
        ...state,
        configurations,
        configurationsLoading: false,
    }),

    [actions.RECEIVE_SOURCE]: (
        state,
        { source }: actions.PackageSource,
    ): IDeployment => ({
        ...state,
        editor: { visible: true, source: source },
    }),

    [actions.CLOSE_EDITOR]: (state) => ({
        ...state,
        editor: { visible: false, source: undefined },
    }),

    [actions.RECEIVE_PACKAGE_DIFF]: (
        state,
        { packageDiff }: actions.ReceivePackageDiff,
    ): IDeployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [packageDiff.configuration.id]: {
                configuration: packageDiff.configuration,
                baselineTime: packageDiff.baselineTime,
                snapshotTime: packageDiff.snapshotTime,
                changes: packageDiff.changes,
                addinDiffs: [],
                addinDiffsLoading: false,
            },
        },
    }),

    [actions.REQUEST_PACKAGE_ADDIN_DIFFS]: (
        state,
        { id }: actions.ConfigurationId,
    ): IDeployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [id]: {
                ...state.packageDiffs[id],
                addinDiffsLoading: true,
            },
        },
    }),

    [actions.RECEIVE_PACKAGE_ADDIN_DIFFS]: (
        state,
        { id, addinDiffs }: actions.ReceivePackageAddinDiffs,
    ): IDeployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [id]: {
                ...state.packageDiffs[id],
                addinDiffs,
                addinDiffsLoading: false,
            },
        },
    }),
}

export default function reducer(
    state: IDeployment = initialState,
    action: Action,
): IDeployment {
    const handler: (state: IDeployment, action: Action) => IDeployment =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
